import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconV2ExportOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="1em" height="1em"><path d="M28 15.4V28H4V4h12.3l-1.4 2H6v20h20v-8.6zM12.7 18l1.4 1.4L25.9 7.6v7l2-2V4.1h-9.3l-1.4 2h7.4l-12 12Z" /></svg>
);
